<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-epigraph element-without-heading" id="epigraph">
<div class="text" id="epigraph-text">
<p class="first first-in-chapter first-full-width"><i>If anyone saith, “I love God,” and hates his brother, he is a liar; for he who does not love his brother whom he has seen, cannot love God whom he has not seen.</i> — <b>John 4:20 English Standard Version (ESV)</b></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width"><i>So we beat on, boats against the current, borne back ceaselessly into the past.</i> <b>— F. Scott Fitzgerald, <i>The Great Gatsby</i></b></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?fec353d4